var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M11 1.28442C5.55576 1.28442 2.53109 5.51868 1.45554 7.40081C1.23488 7.78694 1.12456 7.98001 1.1367 8.26802C1.14885 8.55604 1.27857 8.74423 1.53799 9.12061C2.8182 10.978 6.29389 15.2844 11 15.2844C15.7061 15.2844 19.1818 10.978 20.462 9.12061C20.7214 8.74423 20.8511 8.55604 20.8633 8.26802C20.8754 7.98001 20.7651 7.78694 20.5445 7.40081C19.4689 5.51868 16.4442 1.28442 11 1.28442Z",
    stroke: "#1D1D46"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-circle": "stroke",
    cx: 11,
    cy: 8.28442,
    r: 3,
    stroke: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ae15445d2f5e44abefa3f16acdfc7eef.svg";
export { ForwardRef as ReactComponent };